const SALARY_PAYMENT_METHOD = {
  DEPOSIT_TO_BANK_ACCOUNT: "DEPOSIT_TO_BANK_ACCOUNT",
  TRANSFER_TO_E_WALLET: "TRANSFER_TO_E_WALLET",
  RETAIN_WITH_EMPLOYER: "RETAIN_WITH_EMPLOYER",
};

export {SALARY_PAYMENT_METHOD};
